import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IActionButton } from '../../models/action-button.model';
import { IAddress } from '../../models/address.model';
import { IAddressEvent } from '../../models/address-event.model';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressComponent {
  @Input() address: IAddress;
  @Input() actionList: IActionButton[];

  @Output() action = new EventEmitter<IAddressEvent>();

  public readonly actionsTooltipLabel = 'SHARED.ADDRESS.MANAGE_ADDRESS.TOOLTIP';

  public onActionClick(event): void {
    this.action.emit({
      type: event,
      target: this.address,
    });
  }
}
